import React, { useState } from "react";
import "./SimulacrumExplorerStyle.css";

function ImageModal({ image, name, onClose }) {
    const [isZoomed, setIsZoomed] = useState(false);
    // Default to center (50% 50%)
    const [origin, setOrigin] = useState({ x: 50, y: 50 });

    const toggleZoom = (e) => {
        e.stopPropagation(); // Prevent closing the modal
        setIsZoomed((prev) => !prev);
    };

    const handleOverlayMouseMove = (e) => {
        if (isZoomed) {
            const rect = e.currentTarget.getBoundingClientRect();
            // Calculate mouse position as a percentage of the overlay-content size
            const originX = ((e.clientX - rect.left) / rect.width) * 100;
            const originY = ((e.clientY - rect.top) / rect.height) * 100;
            setOrigin({ x: originX, y: originY });
        }
    };

    return (
        <div className="overlay" onClick={onClose}>
            {/* Close button pinned to top left */}
            <button className="close-button" onClick={onClose}>
                Close
            </button>
            <div
                className="overlay-content"
                onMouseMove={handleOverlayMouseMove}
                onClick={(e) => e.stopPropagation()}
            >
                <img
                    src={image}
                    alt={name}
                    className="overlay-image"
                    onClick={toggleZoom}
                    style={{
                        transform: isZoomed ? "scale(2)" : "scale(1)",
                        transformOrigin: `${origin.x}% ${origin.y}%`,
                        transition: "transform 0.3s ease, transform-origin 0.3s ease",
                        cursor: isZoomed ? "move" : "pointer"
                    }}
                />
            </div>
        </div>
    );
}

export default ImageModal;
